module.exports = __webpack_public_path__ + "static/media/paz-take.3164738b.png";